var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editEvent }
            },
            [_vm._v("Edit Event")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.event
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.eventId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Title")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.title))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.description))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Long Description")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.longDescription))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Start Date")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.start_date))])
              ]),
              _c("tr", [
                _c("th", [_vm._v("End Date")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.end_date))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Chatroll Event Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.chatroll_event_id))])
              ]),
              _c("tr", [
                _c("th", [_vm._v("Chatroll Event Name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.chatroll_event_name))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Duration")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.duration))])
              ]),
              _c("tr", [
                _c("th", [_vm._v("Expert Name(s)")]),
                _vm._v(" "),
                _vm.event
                  ? _c("td", [_vm._v(_vm._s(_vm.event.csvExpertsNames))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", { staticClass: "align-content-center" }, [
                  _vm._v("Image")
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("img", {
                    staticClass: "detail-thumbnail",
                    attrs: { src: _vm.event.img_url, alt: "event-image" }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Jw Rtmp Url")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.jw_rtmp_url))])
              ]),
              _c("tr", [
                _c("th", [_vm._v("Video Code")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.jw_stream_title))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Switch Time (Minutes)")]),
                _vm._v(" "),
                _vm.event.eventSwitchTime
                  ? _c("td", [_vm._v(_vm._s(_vm.event.eventSwitchTime))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Tags")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.tags))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Has Archive Playlist?")]),
                _vm._v(" "),
                _vm.event.toneLive == "1"
                  ? _c("td", [_vm._v("Yes")])
                  : _c("td", [_vm._v("No")])
              ]),
              _vm._v(" "),
              _c("tr"),
              _c("tr", [
                _c("th", [_vm._v("Corporation")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.event.corporationName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Is Private?")]),
                _vm._v(" "),
                _c("td", [
                  _vm.event.isPrivate === 1
                    ? _c("span", [_vm._v("Yes")])
                    : _c("span", [_vm._v("No")])
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Enable Corporate Archiving?")]),
                _vm._v(" "),
                _c("td", [
                  _vm.event.corporateEventArchive === 1
                    ? _c("span", [_vm._v("Yes")])
                    : _c("span", [_vm._v("No")])
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Type")]),
                _vm._v(" "),
                _vm.event.type == "1"
                  ? _c("td", [_vm._v("Live Event")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.event.type == "2"
                  ? _c("td", [_vm._v("Talk Event")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.event.type == "3"
                  ? _c("td", [_vm._v("Corporation self-hosted Event")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.event.status == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Event Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a72090fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a72090fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Events/EventDetails.vue
// module id = xh91
// module chunks = 0